import React from 'react'
import {Typography} from '@mui/material';

const Header = () => {
  const titleStyle = {
    display: 'flex',
    margin: '100px',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'black'
  };
  return (
    <>
    <div className='heading' style={titleStyle}>
     <h1> What would you like to do ?</h1>
     <span>Explore Material Capabilities here</span>
    </div> 
    </>
  )
}

export default Header;